import { Button, Typography, Box } from '@mui/material';

import WarningIcon from '@mui/icons-material/WarningAmber';

import Modal from '../../../Modal/Modal';

import { ConflictList } from './ConflictList';
import { DialogContainer, DialogHeader, DialogDescription, DialogActions } from './ConflictWarningModal.styles';

export default function ConflictWarningModal({ conflicts, handleClose, handleAssign, selectedEmployee }) {
  if (!conflicts.length) return null;

  return (
    <Modal
      open={true}
      onClose={handleClose}
      width={480}
      maxHeight="90vh"
      alignContent="left"
      ariaLabelledBy="alert-dialog-title"
      variant="default"
    >
      <DialogContainer>
        <DialogHeader id="alert-dialog-title">
          <WarningIcon />
          <Typography variant="h6" component="h2">
            Shift assignment warning
          </Typography>
        </DialogHeader>
        <Box>
          <DialogDescription id="alert-dialog-description">
            {conflicts[0].type.includes('role')
              ? `${selectedEmployee.displayName} is not trained for this role.`
              : `${selectedEmployee.displayName} has availability conflicts with this shift:`}
          </DialogDescription>
          <ConflictList conflicts={conflicts} />
        </Box>
        <DialogActions>
          <Button variant="primary" onClick={handleAssign}>
            Assign anyway
          </Button>
          <Button variant="primaryDestructive" onClick={handleClose} autoFocus>
            Cancel
          </Button>
        </DialogActions>
      </DialogContainer>
    </Modal>
  );
}
